export default (function removeParagraphTags(html) {
  return html.replace(/<\/p>/gmi, " ").replace(/<p.*?>/gmi, "");
});